import { __assign } from "tslib";
import { default as GALLERY_v4_CONSTS } from '../constants';
import { experimentsWrapper } from '../sdk/experimentsWrapper';
var getFormattedDuration = function (milliseconds) {
    // convert milliseconds duration to ISO 8601 duration format (e.g., PT5M01S)
    var duration = "PT".concat(Math.floor(milliseconds / 60000), "M").concat(((milliseconds % 60000) /
        1000)
        .toFixed(0)
        .padStart(2, '0'), "S");
    return duration;
};
var getSeoVideoProperties = function (galleryItem) {
    var _a, _b, _c, _d, _e, _f, _g;
    if ((galleryItem === null || galleryItem === void 0 ? void 0 : galleryItem.type) !== 'video') {
        return {};
    }
    return {
        contentUrl: !((_a = galleryItem === null || galleryItem === void 0 ? void 0 : galleryItem.metaData) === null || _a === void 0 ? void 0 : _a.isExternal)
            ? (_d = (_c = (_b = galleryItem.metaData) === null || _b === void 0 ? void 0 : _b.qualities) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.url
            : '',
        uploadDate: (_e = galleryItem === null || galleryItem === void 0 ? void 0 : galleryItem.dto) === null || _e === void 0 ? void 0 : _e.createdDate,
        duration: getFormattedDuration(galleryItem.metaData.duration) || '',
        embedUrl: ((_f = galleryItem === null || galleryItem === void 0 ? void 0 : galleryItem.metaData) === null || _f === void 0 ? void 0 : _f.isExternal)
            ? ((_g = galleryItem === null || galleryItem === void 0 ? void 0 : galleryItem.metaData) === null || _g === void 0 ? void 0 : _g.videoUrl) || ''
            : '',
    };
};
export var constructMetaTagsItemData = function (galleryItem, page_url, fullscreen_url) { return ({
    item: __assign(__assign(__assign({ id: galleryItem.id, type: galleryItem.type, title: galleryItem.title, description: galleryItem.description, // image-description
        page_url: page_url, fullscreen_url: fullscreen_url, image: {
            url: galleryItem.createUrl(GALLERY_v4_CONSTS.urlSizes.RESIZED, GALLERY_v4_CONSTS.urlTypes.HIGH_RES),
            width: galleryItem.width,
            height: galleryItem.height,
        } }, (!experimentsWrapper.getExperimentBoolean('specs.pro-gallery.addSEOVideoMetaTags')
        ? {
            video_url: galleryItem.videoUrl ||
                galleryItem.createUrl(GALLERY_v4_CONSTS.urlSizes.RESIZED, GALLERY_v4_CONSTS.urlTypes.VIDEO),
        }
        : {})), { thumbnail: {
            url: galleryItem.createUrl(GALLERY_v4_CONSTS.urlSizes.RESIZED, GALLERY_v4_CONSTS.urlTypes.LOW_RES),
            width: 250,
            height: 250,
        } }), (experimentsWrapper.getExperimentBoolean('specs.pro-gallery.addSEOVideoMetaTags') && galleryItem.type === 'video'
        ? getSeoVideoProperties(galleryItem)
        : {})),
}); };
export default constructMetaTagsItemData;
//# sourceMappingURL=seoUtils.js.map